<template>
  <div v-if="item && isShowModel" class="mode14-box relative">
    <div
      class="relative new-mode-header"
      v-exposure="{ eid: `101_32_${curindex}_0` }"
      :data-id="`101_32_${curindex}_0`"
      :class="titleAlignmentClass"
    >
      <div>
        <div class="title-left">
          <img
            class="title-icon"
            v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
            :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
            alt
          />
          <span class="title">{{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub">{{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.subTitle }}</div>
      </div>
    </div>
    <!-- {{ total }} -->
    <div class="mo14-content">
      <div v-if="!getIsMobile" class="modeMainPc">
        <div class="modeContent relative">
          <div class="left absolute">
            <div>{{ $t("Datalang.home_hight") }}</div>
            <div class="numColor numColor2">{{ maxRatio }}%</div>
          </div>
          <el-row class="right" :gutter="15">
            <el-col :span="8" v-if="userRechargeDetail.firstRecharge.activityIsValid === 'STATUS_BOOL_TRUE'">
              <div
                class="rightMode relative"
                :class="{
                  'rmStyle2 child1': showType === 2 && userRechargeDetail.firstRecharge.canDo !== 'STATUS_BOOL_TRUE',
                  style2: showType === 2,
                }"
              >
                <div
                  v-if="userRechargeDetail.firstRecharge.canDo !== 'STATUS_BOOL_TRUE'"
                  class="rightModeBg absolute"
                ></div>
                <div class="top">
                  <span>{{ $t("Datalang.newly_First_charge") }}</span>
                  <span v-if="userRechargeDetail.firstRecharge.canDo === 'STATUS_BOOL_TRUE'" class="time">{{
                    surplusTxt
                  }}</span>
                </div>
                <div class="mid">
                  <span>{{ $t("Datalang.home_hight") }}</span>
                  <span class="numColor numColor1">&nbsp;&nbsp;{{ userCoinSymbol }}&nbsp;</span>
                  <span class="numColor">{{ (Number(userRechargeDetail.firstRecharge.ratio) + 10000) / 100 }}%</span>
                  <img
                    v-if="showType === 2"
                    class="fr goImg"
                    :src="goImg"
                    @click="goCharge"
                    v-exposure="{ eid: `101_32_${curindex}_1` }"
                    :data-id="`101_32_${curindex}_1`"
                    alt
                  />
                </div>
                <div class="fot" v-if="showType === 1">
                  <el-button
                    type="primary"
                    class="modeBtn"
                    @click="goCharge"
                    v-exposure="{ eid: `101_32_${curindex}_1` }"
                    :data-id="`101_32_${curindex}_1`"
                  >
                    <span>{{ $t("Datalang.Menu_BTM_recharge") }}</span>
                    <img class="modeBtnImg absolute" :src="goldImg" alt />
                    <div class="modeBtnSelect absolute">98%&nbsp;{{ $t("Datalang.home_selected") }}</div>
                  </el-button>
                </div>
              </div>
            </el-col>
            <el-col :span="8" v-if="userRechargeDetail.sign.activityIsValid === 'STATUS_BOOL_TRUE'">
              <div
                class="rightMode relative"
                :class="{
                  'rmStyle2 child1': showType === 2 && userRechargeDetail.sign.canDo !== 'STATUS_BOOL_TRUE',
                  style2: showType === 2,
                }"
              >
                <div v-if="userRechargeDetail.sign.canDo !== 'STATUS_BOOL_TRUE'" class="rightModeBg absolute"></div>
                <div class="top">
                  <span>{{ SignEventStatus() ? $t("Datalang.home_airdrop") : $t("Datalang.Signin_signin") }}</span>
                  <span v-if="userRechargeDetail.sign.canDo === 'STATUS_BOOL_TRUE'" class="time">{{ surplusTxt }}</span>
                </div>
                <div class="mid">
                  <span>{{ $t("Datalang.home_free_claim") }}</span>
                  <span class="numColor numColor1">&nbsp;&nbsp;{{ userCoinSymbol }}&nbsp;</span>
                  <span class="numColor">{{ divideAccuracy(userRechargeDetail.sign.amount, userAccuracy) }}</span>
                  <img
                    v-if="showType === 2"
                    class="fr goImg"
                    :src="goImg"
                    @click="goSign"
                    v-exposure="{ eid: `101_32_${curindex}_2` }"
                    :data-id="`101_32_${curindex}_2`"
                    alt
                  />
                </div>
                <div class="fot" v-if="showType === 1">
                  <el-button
                    type="primary"
                    class="modeBtn"
                    @click="goSign"
                    v-exposure="{ eid: `101_32_${curindex}_2` }"
                    :data-id="`101_32_${curindex}_2`"
                  >
                    <span>{{ $t("Datalang.home_free_claim") }}</span>
                    <img class="modeBtnImg absolute" :src="giftImg" alt />
                  </el-button>
                </div>
              </div>
            </el-col>
            <el-col :span="8" v-if="userRechargeDetail.repeatRecharge.activityIsValid === 'STATUS_BOOL_TRUE'">
              <div
                class="rightMode relative"
                :class="{
                  'rmStyle2 child3': showType === 2 && userRechargeDetail.repeatRecharge.canDo !== 'STATUS_BOOL_TRUE',
                  style2: showType === 2,
                }"
              >
                <div
                  v-if="userRechargeDetail.repeatRecharge.canDo !== 'STATUS_BOOL_TRUE'"
                  class="rightModeBg absolute"
                ></div>
                <div class="top">
                  <span>{{ $t("Datalang.newly_Recharge_reward") }}</span>
                  <span v-if="userRechargeDetail.repeatRecharge.canDo === 'STATUS_BOOL_TRUE'" class="time">{{
                    surplusTxt
                  }}</span>
                </div>
                <div class="mid">
                  <span>{{ $t("Datalang.home_hight") }}</span>
                  <span class="numColor numColor1">&nbsp;&nbsp;{{ userCoinSymbol }}&nbsp;</span>
                  <span class="numColor">{{ (Number(userRechargeDetail.repeatRecharge.ratio) + 10000) / 100 }}%</span>
                  <img
                    v-if="showType === 2"
                    class="fr goImg"
                    :src="goImg"
                    @click="goCharge('3')"
                    v-exposure="{ eid: `101_32_${curindex}_3` }"
                    :data-id="`101_32_${curindex}_3`"
                    alt
                  />
                </div>
                <div class="fot" v-if="showType === 1">
                  <el-button
                    type="primary"
                    class="modeBtn"
                    @click="goCharge('3')"
                    v-exposure="{ eid: `101_32_${curindex}_3` }"
                    :data-id="`101_32_${curindex}_3`"
                  >
                    <span>{{ $t("Datalang.Menu_BTM_recharge") }}</span>
                    <img class="modeBtnImg absolute" :src="goldImg" alt />
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-else class="modeMainH5">
        <div class="modeHeader">
          <span>{{ $t("Datalang.home_hight") }}</span>
          <span class="numColor numColor1">&nbsp;{{ maxRatio }}%</span>
        </div>
        <div class="rightModeBox">
          <div
            class="rightMode relative"
            :class="{
              'rmStyle2 child1':
                showType === 2 && userRechargeDetail.firstRecharge.activityIsValid !== 'STATUS_BOOL_TRUE',
              style2: showType === 2,
            }"
            v-if="userRechargeDetail.firstRecharge.activityIsValid === 'STATUS_BOOL_TRUE'"
          >
            <div
              v-if="userRechargeDetail.firstRecharge.canDo !== 'STATUS_BOOL_TRUE'"
              class="rightModeBg absolute"
            ></div>
            <div class="top">
              <span>{{ $t("Datalang.newly_First_charge") }}</span>
              <span v-if="userRechargeDetail.firstRecharge.canDo === 'STATUS_BOOL_TRUE'" class="time">{{
                surplusTxt
              }}</span>
            </div>
            <div class="mid">
              <span>{{ $t("Datalang.home_hight") }}</span>
              <span class="numColor numColor1">&nbsp;&nbsp;{{ userCoinSymbol }}&nbsp;</span>
              <span class="numColor">{{ (Number(userRechargeDetail.firstRecharge.ratio) + 10000) / 100 }}%</span>
              <img
                v-if="showType === 2"
                class="fr goImg"
                :src="goImg"
                @click="goCharge"
                v-exposure="{ eid: `101_32_${curindex}_1` }"
                :data-id="`101_32_${curindex}_1`"
                alt
              />
            </div>
            <div class="fot" v-if="showType === 1">
              <el-button
                type="primary"
                class="modeBtn"
                @click="goCharge"
                v-exposure="{ eid: `101_32_${curindex}_1` }"
                :data-id="`101_32_${curindex}_1`"
              >
                <span>{{ $t("Datalang.Menu_BTM_recharge") }}</span>
                <img class="modeBtnImg absolute" :src="goldImg" alt />
                <div class="modeBtnSelect absolute">98%&nbsp;{{ $t("Datalang.home_selected") }}</div>
              </el-button>
            </div>
          </div>
          <div
            class="rightMode relative"
            :class="{
              'rmStyle2 child2': showType === 2 && userRechargeDetail.sign.activityIsValid !== 'STATUS_BOOL_TRUE',
              style2: showType === 2,
            }"
            v-if="userRechargeDetail.sign.activityIsValid === 'STATUS_BOOL_TRUE'"
          >
            <div v-if="userRechargeDetail.sign.canDo !== 'STATUS_BOOL_TRUE'" class="rightModeBg absolute"></div>
            <div class="top">
              <span>{{ SignEventStatus() ? $t("Datalang.home_airdrop") : $t("Datalang.Signin_signin") }}</span>
              <span v-if="userRechargeDetail.sign.canDo === 'STATUS_BOOL_TRUE'" class="time">{{ surplusTxt }}</span>
            </div>
            <div class="mid">
              <span>{{ $t("Datalang.home_free_claim") }}</span>
              <span class="numColor numColor1">&nbsp;&nbsp;{{ userCoinSymbol }}&nbsp;</span>
              <span class="numColor">{{ divideAccuracy(userRechargeDetail.sign.amount, userAccuracy) }}</span>
              <img
                v-if="showType === 2"
                class="fr goImg"
                :src="goImg"
                @click="goSign"
                v-exposure="{ eid: `101_32_${curindex}_2` }"
                :data-id="`101_32_${curindex}_2`"
                alt
              />
            </div>
            <div class="fot" v-if="showType === 1">
              <el-button
                type="primary"
                class="modeBtn"
                @click="goSign"
                v-exposure="{ eid: `101_32_${curindex}_2` }"
                :data-id="`101_32_${curindex}_2`"
              >
                <span>{{ $t("Datalang.home_free_claim") }}</span>
                <img class="modeBtnImg absolute" :src="giftImg" alt />
              </el-button>
            </div>
          </div>

          <div
            class="rightMode relative"
            :class="{
              'rmStyle2 child3':
                showType === 2 && userRechargeDetail.repeatRecharge.activityIsValid !== 'STATUS_BOOL_TRUE',
              style2: showType === 2,
            }"
            v-if="userRechargeDetail.repeatRecharge.activityIsValid === 'STATUS_BOOL_TRUE'"
          >
            <div
              v-if="userRechargeDetail.repeatRecharge.canDo !== 'STATUS_BOOL_TRUE'"
              class="rightModeBg absolute"
            ></div>
            <div class="top">
              <span>{{ $t("Datalang.newly_Recharge_reward") }}</span>
              <span v-if="userRechargeDetail.repeatRecharge.canDo === 'STATUS_BOOL_TRUE'" class="time">{{
                surplusTxt
              }}</span>
            </div>
            <div class="mid">
              <span>{{ $t("Datalang.home_hight") }}</span>
              <span class="numColor numColor1">&nbsp;&nbsp;{{ userCoinSymbol }}&nbsp;</span>
              <span class="numColor">{{ (Number(userRechargeDetail.repeatRecharge.ratio) + 10000) / 100 }}%</span>
              <img
                v-if="showType === 2"
                class="fr goImg"
                :src="goImg"
                @click="goCharge('3')"
                v-exposure="{ eid: `101_32_${curindex}_3` }"
                :data-id="`101_32_${curindex}_3`"
                alt
              />
            </div>
            <div class="fot" v-if="showType === 1">
              <el-button
                type="primary"
                class="modeBtn"
                @click="goCharge('3')"
                v-exposure="{ eid: `101_32_${curindex}_3` }"
                :data-id="`101_32_${curindex}_3`"
              >
                <span>{{ $t("Datalang.Menu_BTM_recharge") }}</span>
                <img class="modeBtnImg absolute" :src="goldImg" alt />
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mode14 from "@/lobby_common/mixins_views/homeModule/mode14.js";
export default {
  mixins: [mode14],
};
</script>
<style lang="scss" scoped>
.new-mode-header {
  padding: 0px 10px;
}
.pl5 {
  padding-left: 5px;
}
.mode14-header {
  line-height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 15px;
  @media (max-width: 768px) {
    padding: 15px 10px 0px;
  }
  .title-left {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .title-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .title {
    font-size: 1.8rem;
    font-weight: bold;
    color: var(--font-color-1601);
    @media (max-width: 768px) {
      font-size: 15px;
    }
  }
}
.numColor {
  color: var(--font-color-1800);
  font-size: 30px;
  @media (max-width: 768px) {
    font-size: 18px;
  }
}
.numColor1 {
  font-size: 16px;
  @media (max-width: 768px) {
    color: var(--font-color-300);
    font-size: 12px;
  }
}
.numColor2 {
  font-size: 36px;
}
.mo14-content {
  overflow: hidden;
  margin-top: 12px;
  font-size: 16px;
  color: var(--font-color-200);
  @media (max-width: 768px) {
    margin-top: 2px;
  }
  .modeMainPc {
    padding: 10px 18px;
    background: var(--background-1000);
    border-radius: var(--radius-300);
    overflow-x: auto;
    background-image: url("~@/assets/home/modeBg.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
    .modeContent {
      padding-left: 270px;
      .left {
        width: 160px;
        text-align: center;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
        .numColor {
          padding-top: 10px;
        }
      }
      .right {
        min-width: 770px;
        .rightMode {
          padding: 10px 15px;
          border-radius: var(--radius-300);
          min-height: 100px;
          background: var(--background-2000);
          &.rmStyle2 {
            padding: 15px 20px;
            min-height: 50px;
            background-repeat: no-repeat;
            &::after {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-repeat: no-repeat;
            }
            &.child1::after {
              background-image: url("~@/lobby_common/assets/homePage/modeBg1.png");
            }
            &.child2::after {
              background-image: url("~@/lobby_common/assets/homePage/modeBg2.png");
            }
            &.child3::after {
              background-image: url("~@/lobby_common/assets/homePage/modeBg3.png");
            }
          }
          &.style2 {
            padding: 15px 20px;
            min-height: 50px;
          }
          .rightModeBg {
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: #000;
            border-radius: var(--radius-300);
            opacity: 0.35;
            z-index: 5;
          }
          .top {
            display: flex;
            justify-content: space-between;
            .time {
              color: var(--font-color-1200);
            }
          }
          .fot {
            text-align: center;
            padding: 20px 0 0 0;
            .modeBtn {
              position: relative;
              width: 50%;
              height: 40px;
              margin-left: 20px;
              @include buttonPrimary;
              .modeBtnImg {
                width: 45px;
                left: -20px;
                bottom: -5px;
                z-index: 1;
              }
              .modeBtnSelect {
                top: -14px;
                height: 24px;
                line-height: 24px;
                font-size: 14px;
                padding: 0 20px;
                background: var(--password-400);
                z-index: 2;
                border-radius: 12px;
                color: var(--font-color-200);
              }
            }
          }
        }
      }
    }
  }
  .modeMainH5 {
    font-size: 12px;
    .modeHeader {
      color: var(--font-color-100);
      font-size: 14px;
      padding: 0 10px 10px;
      .numColor1 {
        font-size: 14px;
      }
    }
    .rightModeBox {
      display: flex;
      padding: 0 10px;
      overflow-x: auto;
    }
    .rightMode {
      flex: 0 0 auto;
      width: 200px;
      padding: 10px 10px;
      border-radius: var(--radius-301);
      min-height: 90px;
      background: var(--background-2000);
      margin-right: 10px;
      &.style2 {
        padding: 10px 10px;
        min-height: 30px;
      }
      &.rmStyle2 {
        padding: 10px 10px;
        min-height: 30px;
        background-repeat: no-repeat;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-repeat: no-repeat;
        }
        &.child1::after {
          background-image: url("~@/lobby_common/assets/homePage/modeBg1.png");
        }
        &.child2::after {
          background-image: url("~@/lobby_common/assets/homePage/modeBg2.png");
        }
        &.child3::after {
          background-image: url("~@/lobby_common/assets/homePage/modeBg3.png");
        }
        .mid {
          position: relative;
          margin-top: 5px;
        }
      }
      .rightModeBg {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: #000;
        border-radius: var(--radius-301);
        opacity: 0.35;
        z-index: 5;
      }
      .top {
        display: flex;
        justify-content: space-between;
        .time {
          color: var(--font-color-1200);
        }
      }
      .fot {
        text-align: center;
        padding: 15px 0 0 0;
        .modeBtn {
          position: relative;
          width: 70%;
          height: 35px;
          margin-left: 20px;
          line-height: 1px;
          @include buttonPrimary;
          .modeBtnImg {
            width: 40px;
            left: -20px;
            bottom: -5px;
            z-index: 1;
          }
          .modeBtnSelect {
            top: -10px;
            height: 16px;
            line-height: 16px;
            font-size: 10px;
            padding: 0 20px;
            background: var(--password-400);
            z-index: 2;
            border-radius: 8px;
            color: var(--font-color-200);
          }
        }
      }
    }
  }
}
.goImg {
  margin: 5px -5px 0 0;
  cursor: pointer;
  position: absolute;
  right: 10px;
  @media (max-width: 768px) {
    width: 24px;
    margin: 0px -5px 0 0;
  }
}
</style>
<style lang="scss">
.item-img-skeleton {
  position: relative;
  width: 100%;
  max-width: 300px;
  border-radius: var(--radius-300) !important;
  @media (max-width: 768px) {
    border-radius: var(--radius-301) !important;
  }
}
</style>
